const contactUs = {
  title: () => 'Shop italist | Get in touch',
  description: () =>
    'Looking for support? You can send us an email or chat 24/7, our team is at your disposal to answer your questions'
};

export default contactUs;
